import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Ya no me asusto cuando pasa. Ahora sé qué está ocurriendo.',
  author: 'Marta, 51'
}, {
  quote: 'Duermo mejor. No perfecto, pero mucho mejor.',
  author: 'Carmen, 48'
}, {
  quote: 'Pensaba que era solo yo.',
  author: 'Rosa, 53'
}];
export function Testimonials() {
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16" data-id="element-193">
      {testimonials.map((t, idx) => <motion.div key={idx} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: idx * 0.2,
      ease: 'easeOut'
    }} className="flex flex-col justify-between p-8 bg-sand/30 rounded-sm border-l-2 border-sage" data-id="element-194">
          <p className="font-serif text-lg italic text-charcoal/90 mb-6 leading-relaxed" data-id="element-195">
            "{t.quote}"
          </p>
          <p className="text-sm uppercase tracking-wider text-charcoal/60 font-medium" data-id="element-196">
            — {t.author}
          </p>
        </motion.div>)}
    </div>;
}